// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qcNg","colBig":"styles_colBig__1YKp_","colSmall":"styles_colSmall__396Xi"};